/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'sms_fill_blue': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 1.6c-4.413 0-8 2.506-8 5.617 0 1.53.876 2.926 2.29 3.935-.218.555-.656 1.564-1.246 2.354-.32.42.084 1.009.607.874 1.633-.437 3.132-1.26 3.991-1.799.741.168 1.533.252 2.358.252 4.413 0 8-2.505 8-5.616C16 4.106 12.413 1.6 8 1.6zM4.21 8.327a1.11 1.11 0 110-2.22 1.1 1.1 0 011.112 1.11c-.017.622-.505 1.11-1.111 1.11zm3.79 0a1.11 1.11 0 110-2.22 1.1 1.1 0 011.112 1.11A1.11 1.11 0 018 8.327zm3.79 0a1.11 1.11 0 110-2.22 1.11 1.11 0 011.111 1.11 1.1 1.1 0 01-1.111 1.11z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
